import { GovFlex } from '@gov-design-system-ce/react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import {
	RecycleBinOrder,
	useMojeSouborySeznamContext,
} from '@gov-nx/module/page';
import { SortArrows, Space } from '@gov-nx/ui/web';
import { DocumentsActions } from '../DocumentsActions';
import { SelectAll } from '../SelectAll';

export const TableHeadBinned = () => {
	const { code, myFilesFilters, myFilesSelection } =
		useMojeSouborySeznamContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tsn = getLocalizeCurried(code);

	return (
		<GovFlex
			direction="column"
			gap="s"
			className="pt-(--templates-margin-s) pb-(--templates-margin-s) pl-(--templates-margin-l) pr-(--templates-margin-l) bg-(--background-block-secondary) rounded-lg">
			{myFilesSelection.selected.length > 0 ? (
				<GovFlex
					justifyContent="space-between"
					alignItems="center"
					gap="s"
					className="pb-(--templates-margin-s)">
					<span className="font-bold text-(--text-secondary)">
						{tsn('vyber.vybrano')}:<Space />
						{myFilesSelection.selected.length}
					</span>
					<DocumentsActions />
				</GovFlex>
			) : null}
			<GovFlex
				alignItems="center"
				gap="s"
				responsive="false">
				<span className="mr-auto! text-left font-normal text-(--text-primary-color) whitespace-nowrap">
					{tsn('data.nazev-souboru')}
					<SortArrows
						descWcagLabel={`${tsn('razeni.title')}: ${tsn(
							'data.nazev-souboru'
						)} - ${tsn('razeni.sestupne')}`}
						descOnClick={() =>
							myFilesFilters.sortFilesBy(RecycleBinOrder.NAZEV_DESC)
						}
						ascWcagLabel={`${tsn('razeni.title')}: ${tsn(
							'data.nazev-souboru'
						)} - ${tsn('razeni.vzestupne')}`}
						ascOnClick={() => myFilesFilters.sortFilesBy(RecycleBinOrder.NAZEV)}
					/>
				</span>
				<span className="pl-1 text-left font-normal text-(--text-primary-color) whitespace-nowrap hidden [ lg:block ]">
					{tsn('data.odstraneni-za')}
					<SortArrows
						descWcagLabel={`${tsn('razeni.title')}: ${tsn(
							'data.odstraneni-za'
						)} - ${tsn('razeni.sestupne')}`}
						descOnClick={() =>
							myFilesFilters.sortFilesBy(RecycleBinOrder.DNU_DO_ODSTRANENI_DESC)
						}
						ascWcagLabel={`${tsn('razeni.title')}: ${tsn(
							'data.odstraneni-za'
						)} - ${tsn('razeni.vzestupne')}`}
						ascOnClick={() =>
							myFilesFilters.sortFilesBy(RecycleBinOrder.DNU_DO_ODSTRANENI)
						}
					/>
				</span>
				<SelectAll />
			</GovFlex>
		</GovFlex>
	);
};
